import {useTranslation} from 'react-i18next'
import {ConfirmDialog} from '@/components/confirm-dialog'
import {useAdminUserLookup} from '@/hooks/empresa/organizacion/use-businesses'

/** KAI-438: la cédula ya tiene cuenta. La empresa confirma lo que ella escribió y no ve nada de la cuenta;
 * Inci ve la identidad guardada y, al confirmar, la verifica. */
function ConfirmarIdentidadDialog({
  open,
  onOpenChange,
  descripcion,
  porque,
  onConfirm,
  pending,
  disabled,
  error,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  descripcion: string
  /** El de la empresa no dice nada de la cuenta; el de Inci dice que confirmar la verifica. */
  porque: string
  onConfirm: () => void
  pending?: boolean
  disabled?: boolean
  error?: string | null
}) {
  const {t} = useTranslation()
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('verificacionIdentidad.confirmar.title')}
      description={descripcion}
      confirmLabel={t('verificacionIdentidad.confirmar.submit')}
      cancelLabel={t('common.cancel')}
      onConfirm={onConfirm}
      pending={pending}
      disabled={disabled}
      error={error}
      porque={{
        label: t('verificacionIdentidad.confirmar.porqueLabel'),
        contenido: porque,
        testId: 'confirmar-identidad-porque',
        contenidoTestId: 'confirmar-identidad-porque-texto',
      }}
    />
  )
}

/** En la consola: Inci ve la identidad guardada de la cuenta, y confirmarla la verifica. */
export function ConfirmarCuentaDeInciDialog({
  cedula,
  open,
  onOpenChange,
  onConfirm,
  pending,
}: {
  cedula: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  pending?: boolean
}) {
  const {t} = useTranslation()
  const {data: cuenta} = useAdminUserLookup(open ? cedula : '')
  const nombre = cuenta ? `${cuenta.name} ${cuenta.last_name}` : ''
  return (
    <ConfirmarIdentidadDialog
      open={open}
      onOpenChange={onOpenChange}
      descripcion={
        cuenta?.correo_verificado
          ? t('verificacionIdentidad.confirmar.inci', {nombre, correo: cuenta.correo_verificado})
          : t('verificacionIdentidad.confirmar.inciSinCorreo', {nombre})
      }
      porque={t('verificacionIdentidad.confirmar.porqueInci')}
      onConfirm={onConfirm}
      pending={pending}
      // Confirmar verifica a la persona: nunca antes de que Inci vea la identidad guardada.
      disabled={!cuenta?.existe}
    />
  )
}

/** La empresa confirma con lo que ella escribió: de la cuenta no ve nada. */
export function ConfirmarAltaDialog({
  open,
  onOpenChange,
  nombre,
  cedula,
  onConfirm,
  pending,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  nombre: string
  cedula: string
  onConfirm: () => void
  pending?: boolean
}) {
  const {t} = useTranslation()
  return (
    <ConfirmarIdentidadDialog
      open={open}
      onOpenChange={onOpenChange}
      descripcion={t('verificacionIdentidad.confirmar.empresa', {nombre, cedula})}
      porque={t('verificacionIdentidad.confirmar.porqueEmpresa')}
      onConfirm={onConfirm}
      pending={pending}
    />
  )
}
